import { getEntries, getEntryById } from '@/fleet-configuration/data-fleet/entries/entries-selectors'

export const getDevices = state => getEntries(state, 'entries.devices')
export const getDeviceById = (state, deviceId) => getEntryById(state, 'entries.devices', deviceId)
export const areDevicesLoaded = state => state.entries.devices.loaded
